import { ActiveMarkup, FokParameterChoiceInput } from '@fora-monorepo/employer-my-pages-common/types';

export const hasParametersChanged = (
  parameterChoicesInput: {
    fokParameter: FokParameterChoiceInput;
    validateInput: () => boolean;
  }[],
  activeMarkup: ActiveMarkup | null
) => {
  return !parameterChoicesInput.every(({ fokParameter }) => {
    const activeParam = activeMarkup?.fokParameterChoices.find(
      activeParam => activeParam.parameterValue === fokParameter.parameterValue
    );
    if (!activeParam) return false;

    return (
      ((!activeParam?.endDate && !fokParameter.endDate) || activeParam.endDate === fokParameter.endDate) &&
      ((!activeParam?.startDate && !fokParameter.startDate) || activeParam.startDate === fokParameter.startDate)
    );
  });
};
